<template>
  <div class="allBox">
    <transition name="default" mode="out-in">
      <router-view
        :update-component="updateComponent"
        :key="$route.path"
      ></router-view>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      updateComponent: new Date().toString()
    }
  }
}
</script>
<style scoped>
.allBox {
  width: 100%;
  height: 100%;
  overflow: scroll;
  padding: 0;
}
</style>
